"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Tooltip: function() {
        return _Tooltip.Tooltip;
    },
    renderTooltip_unstable: function() {
        return _Tooltip.renderTooltip_unstable;
    },
    tooltipClassNames: function() {
        return _Tooltip.tooltipClassNames;
    },
    useTooltipStyles_unstable: function() {
        return _Tooltip.useTooltipStyles_unstable;
    },
    useTooltip_unstable: function() {
        return _Tooltip.useTooltip_unstable;
    }
});
const _Tooltip = require("./Tooltip");
 // Experimental APIs - will be uncommented in experimental release
 // export { useTooltipBase_unstable } from './Tooltip';
 // export type { TooltipBaseProps, TooltipBaseState } from './Tooltip';
